import { render } from "./class-list.vue?vue&type=template&id=027710e9&scoped=true"
import script from "./class-list.vue?vue&type=script&lang=js"
export * from "./class-list.vue?vue&type=script&lang=js"

import "./class-list.vue?vue&type=style&index=0&id=027710e9&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\LessonPlay\\lessonplay_shell\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-027710e9"]])

export default __exports__